/** biome-ignore-all lint/style/noRestrictedImports: date-fns imports are allowed in @cobliteam/utils only. All other packages must import from @cobliteam/utils/date. */
import { ptBR } from 'date-fns/locale';

export const DEFAULT_LOCALE = ptBR;
export const DEFAULT_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
